import { TableCell, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

interface KeywordBankSkeletonRowProps {
  idx: number;
  readOnly: boolean;
  stickyStyle: React.CSSProperties;
  stickyGrid: string;
}

export function KeywordBankSkeletonRow({
  idx,
  readOnly,
  stickyStyle,
  stickyGrid,
}: KeywordBankSkeletonRowProps) {
  return (
    <TableRow key={`kw-skeleton-${idx}`}>
      <TableCell sticky style={stickyStyle} className="py-0 px-0">
        <div className={stickyGrid}>
          {!readOnly && (
            <span className="py-2 px-2 flex items-center justify-center">
              <Skeleton className="h-4 w-4" />
            </span>
          )}
          <span className="py-2 flex items-center justify-center">
            <Skeleton className="h-4 w-4" />
          </span>
          <span className="py-2 px-3">
            <Skeleton className="h-4 w-44" />
          </span>
        </div>
      </TableCell>
      <TableCell className="w-[90px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-10 mx-auto" />
      </TableCell>
      <TableCell className="w-[64px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-8 mx-auto" />
      </TableCell>
      <TableCell className="w-[110px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-16 mx-auto" />
      </TableCell>
      <TableCell className="w-[110px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-16 mx-auto" />
      </TableCell>
      <TableCell className="w-[110px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-14 mx-auto" />
      </TableCell>
      <TableCell className="w-[120px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-14 mx-auto" />
      </TableCell>
      <TableCell className="w-[60px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-8 mx-auto" />
      </TableCell>
      <TableCell className="w-[84px] min-w-[84px] py-2 px-2 text-center">
        <Skeleton className="h-4 w-12 mx-auto" />
      </TableCell>
      <TableCell className="w-[115px] py-1.5 px-2">
        <Skeleton className="h-5 w-24" />
      </TableCell>
      <TableCell className="w-[123px] py-1.5 px-2">
        <Skeleton className="h-5 w-28" />
      </TableCell>
      <TableCell className="w-[138px] py-1.5 px-2">
        <Skeleton className="h-5 w-32" />
      </TableCell>
      {!readOnly && (
        <TableCell className="w-[70px] py-1.5 px-2 text-center">
          <Skeleton className="h-6 w-6 rounded-md mx-auto" />
        </TableCell>
      )}
    </TableRow>
  );
}
